import { oauthTokenSelector } from 'selectors/app/base'

import integrationApi from '../../api'

const getRestId = gid => gid.split('/').pop()

const getRestockType = (restock, order) => {
  const { displayFulfillmentStatus } = order
  const isFulfilled = displayFulfillmentStatus === 'FULFILLED'
  if (!restock) {
    return 'no_restock'
  } else if (isFulfilled) {
    return 'return'
  }
  return 'cancel'
}

const doCalculateRefund = (integrationId, orderId, data) => (
  dispatch,
  getState
) => {
  const state = getState()
  const token = oauthTokenSelector(state)
  const orderRestId = getRestId(orderId)

  const url = `proxy/shopify/admin/api/2021-10/orders/${orderRestId}/refunds/calculate.json?gid=${integrationId}`

  const restockType = getRestockType(data.restock, data.order)

  const shipping = { amount: data.shipping || 0 }
  const items = data.orderItems.map(item => {
    const restId = getRestId(item.id)
    return {
      line_item_id: restId,
      quantity: item.refundQuantity,
      restock_type: restockType,
    }
  })

  const payload = {
    refund: {
      shipping,
      refund_line_items: items,
    },
  }

  const body = JSON.stringify(payload)

  return integrationApi
    .post(token, url, null, body)
    .then(response => response.json)
}

export default doCalculateRefund
